import Pagination from "../common/Pagination";
import { SearchItem } from "./SearchPage";

export default class SearchPagination extends Pagination<SearchItem> {}
